// 하나 바이블 목록을 분리해서 보여줄 division (노출 순서대로)
export const HANA_DIVISIONS = [
  "공과시연",
  "성경 스토리",
  "가정예배",
  "단원챈트",
  "단원찬양",
  "단원영상",
  "기타",
  "선행학습",
  "나무를보다",
  "교사교육",
  "공과강의",
  "오감 활동",
  "찬양,챈트",
  "학습요점",
  "단원송 챈트",
  "미션북정답",
  "찬양,암송곡",
  "스토리텔링",
  "길을 걷다",
];
